import { DealDetailsTab } from "./tabs/DealDetailsTab";
import { DealCompanyTab, DealContactsTab } from "./tabs/DealCompanyTabs";
import { DealTasksDisplay } from "./tabs/DealTasksTab";
import { DealTimelineDisplay } from "./tabs/DealTimelineTab";
import { DealCommunicationsDisplay, DealQuickBooksDisplay } from "./tabs/DealActivityTabs";
import { DealProjectHealthTab } from "./tabs/DealProjectHealthTab";
import { DealContractsDisplay } from "./tabs/DealContractsDisplayTab";
import { DealProjectChannelCard } from "@/components/deals/DealProjectChannelCard";
import type { TabContentProps } from "@/components/shared/UniversalDetailPage/types/detailPage";
import type { Deal } from "@/lib/types/database/deals";

export const DealDetailTabComponents = {
  DealDetailsTab,
  DealCompanyTab,
  DealContactsTab,
  DealTasksDisplay,
  DealTimelineDisplay,
  DealCommunicationsDisplay,
  DealQuickBooksDisplay,
  DealProjectHealthTab,
  DealContractsDisplay,
  DealProjectChannelDisplay: ({ item }: TabContentProps<Deal>) => (
    <DealProjectChannelCard dealId={item.id} />
  ),
};
